module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-standside-2000.e531fc5f.svg";